import { useEffect, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { api } from "@/lib/api";

export default function AuthCallback() {
  const navigate = useNavigate();
  const location = useLocation();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;
    const sessionId = new URLSearchParams(location.hash.replace("#", "")).get("session_id");
    api
      .post("/auth/session", { session_id: sessionId })
      .then((res) => {
        navigate("/admin", { state: { user: res.data }, replace: true });
      })
      .catch(() => {
        navigate("/admin", { replace: true });
      });
  }, [location.hash, navigate]);

  return (
    <div data-testid="auth-callback-loading" className="min-h-screen bg-[#0D0B0E] flex items-center justify-center">
      <div className="text-center">
        <div className="w-10 h-10 border-2 border-[#E890A7]/30 border-t-[#E890A7] rounded-full animate-spin mx-auto" />
        <p className="mt-6 text-sm text-slate-400 font-mono tracking-widest uppercase">Signing you in…</p>
      </div>
    </div>
  );
}
